import Grid from '@mui/material/Grid';
import Layout from '../../componentsv2/Layout';
import Skeleton from '../../componentsv2/Skeleton';

export default function InvoicingSkeleton() {
  return (
    <Layout>
      <Grid container rowSpacing={2}>
        <Grid item xs={8} md={9} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Skeleton width="60%" height="36px" />
          <Skeleton width="40%" height="21px" />
        </Grid>
        <Grid item xs={4} md={3} sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
          <Skeleton width={160} height="40px" />
        </Grid>
        <Grid item xs={12}>
          <Skeleton width="100%" height={160} />
        </Grid>
      </Grid>
    </Layout>
  );
}
